import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskCompletePunctualPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskCompletePunctualPage;
